let translations: Record<string, string> = {};
let uiLanguage: string = '';
let debug = false;

(function initTranslations() {
    const elements = document.getElementsByName('umbraco-translations');
    if (elements.length === 0) return;

    try {
        elements.forEach(el => {
            const json = el.textContent || el.innerHTML || '{}';
            const parsed = JSON.parse(json);
            if (parsed.uiLanguage) {
                uiLanguage = parsed.uiLanguage;
            }
            if (parsed.debug) {
                debug = true;
            }
            Object.entries(parsed.translations).forEach(([key, value]) => translations[key.toLowerCase()] = value as string);
        });
    } catch (err) {
        console.error('Failed to parse Umbraco translations', err);
    }
})();

/**
 * Simple translation helper.
 * Supports {0}, {1}, ... placeholders.
 */
export function t(key: string, ...args: Array<string | number>): string {
    let template = translations[key.toLowerCase()];

    // fallback: show key if missing
    if (!template)
        return `#-${key}-#`;
    if (!args.length)
        return !debug ? template : template + ` #${key}#`;
    return template.replace(/\{(\d+)}/g, (match, indexStr) => {
        const index = Number(indexStr);
        return args[index] != null ? String(args[index]) : match;
    });
}

export function uiL(): string {
    return uiLanguage;
} 